import type { IProductEmailCategory } from '../redux/emailTemplates/types';

export const CUSTOM_TEMPLATE_CATEGORY: IProductEmailCategory = {
    id: 'custom-template',
    label: 'Custom template',
    description: 'GrapesJS / saved HTML template blast',
    entity: null,
    logType: 'email-template',
    defaultAudience: 'users',
    audiences: ['users', 'platform', 'advanced'],
    requiresSubject: true,
    requiresImage: false,
    contestScoped: false,
};

/** @deprecated Prefer `fetchProductEmailCategories` from redux/emailTemplates/action via useDispatchPromise. */
export { fetchProductEmailCategories } from '../redux/emailTemplates/action';
